export default class NumberHelper {
    public static isValid(value: any) {
        return typeof value === 'number';
    }

    public static isPositive(value: any) {
        return NumberHelper.isValid(value) && value > 0;
    }

    public static isPositiveIncludeZero(value: any) {
        return NumberHelper.isValid(value) && value >= 0;
    }

    public static randomNumberInRange(min: number, max: number): number {
        return Math.floor(Math.random() * (max - min + 1) + min);
    }

    public static parseInteger(value: any, defaultValue: number | null = null) {
        if (value) {
            if (typeof value === 'string') {
                return Number.parseInt(value);
            }

            if (typeof value === 'number') {
                return Math.ceil(value);
            }
        }

        return defaultValue;
    }

    public static parseIntegerDefaultZero(value: any) {
        return this.parseInteger(value) ?? 0;
    }

    public static parseFloat(value: any, defaultValue: number | null = null) {
        if (value) {
            if (typeof value === 'string') {
                return Number.parseFloat(value);
            }

            if (typeof value === 'number') {
                return value;
            }
        }

        return defaultValue;
    }

    public static parseNonNegativeInteger(value: unknown): number {
        const parsedValue = NumberHelper.parseIntegerDefaultZero(value);
        if (NumberHelper.isPositiveIncludeZero(parsedValue) === false) {
            return 0;
        }

        return parsedValue;
    }
}
